/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './module';
export {ScrollDirection, MatPaginatedTabHeader} from './paginated-tab-header';
export {
  MatTabBodyPortal,
  MatTabBody,
  MatTabBodyPositionState,
  MatTabBodyOriginState,
  _MatTabBodyBase,
} from './tab-body';
export {MatTabsConfig, MAT_TABS_CONFIG} from './tab-config';
export {MatTabContent, MAT_TAB_CONTENT} from './tab-content';
export {MatTabLabel, MAT_TAB, MAT_TAB_LABEL} from './tab-label';
export {MatTabLabelWrapper} from './tab-label-wrapper';
export {MatTab, MAT_TAB_GROUP, _MatTabBase} from './tab';
export {
  MatInkBar,
  _MatInkBarPositioner,
  _MAT_INK_BAR_POSITIONER_FACTORY,
  _MAT_INK_BAR_POSITIONER,
} from './ink-bar';
export {MatTabHeader, _MatTabHeaderBase} from './tab-header';
export {
  MatTabGroup,
  MatTabChangeEvent,
  MatTabGroupBaseHeader,
  MatTabHeaderPosition,
  _MatTabGroupBase,
} from './tab-group';
export {
  MatTabNav,
  MatTabNavPanel,
  MatTabLink,
  _MatTabNavBase,
  _MatTabLinkBase,
} from './tab-nav-bar/tab-nav-bar';
export {matTabsAnimations} from './tabs-animations';
export {_MatTabLabelWrapperBase} from './tab-label-wrapper';



// WEBPACK FOOTER //
// ../../../../../src/material/tabs/public-api.ts